<template>
  <div>
    <div class="buttonDiv">
      <h1 class="questionTitle">Are you in crisis?</h1>

      <div class="paddingButtons">
        <div data-aos="fade-left" class="radio-toolbar">
          <!-- Q9-1-->

          <span
            v-if="
              $store.state.views.questionNine.checkedButtons[0] === idArry[0]
            "
          >
            <input
              type="radio"
              id="option1"
              v-on:click="setNextTrue"
              name="question8-1"
              value="In Crisis"
              checked
            />

            <label for="option1"> {{ answerOptions1[0] }}</label>
          </span>

          <span v-else>
            <input
              type="radio"
              id="option1"
              v-on:click="setNextTrue"
              name="question8-1"
              value="In Crisis"
            />

            <label for="option1"> {{ answerOptions1[0] }}</label>
          </span>
          <!-- Q9-2-->

          <span
            v-if="
              $store.state.views.questionNine.checkedButtons[0] === idArry[1]
            "
          >
            <input
              type="radio"
              id="option2"
              v-on:click="setNextTrue"
              name="question8-1"
              value="Not in Crisis"
              checked
            />

            <label for="option2"> {{ answerOptions1[1] }}</label>
          </span>

          <span v-else>
            <input
              type="radio"
              id="option2"
              v-on:click="setNextTrue"
              name="question8-1"
              value="Not in Crisis"
            />
            <label for="option2"> {{ answerOptions1[1] }}</label>
          </span>
        </div>
      </div>
    </div>

    <div class="alignRight">
      <div class="bottomDiv">
        <BackButton />
        <button
          v-if="
            isActive || $store.state.views.questionNine.nextButtonActive == true
          "
          v-on:click="nextQuestion"
          class="nextButtonQuestions"
        >
          Next
          <span class="arrow">
            <svg
              width="14"
              height="12"
              viewBox="0 0 14 12"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M8.63466 0.298041C8.45622 0.109282 8.20838 0 7.9308 0C7.38556 0 6.93945 0.447062 6.93945 0.99347C6.93945 1.27164 7.0485 1.52001 7.22694 1.69883L10.4885 4.96735H0.99135C0.446108 4.96735 0 5.41441 0 5.96082C0 6.50723 0.446108 6.95429 0.99135 6.95429H10.4984L7.23686 10.2228C7.05842 10.4016 6.94937 10.65 6.94937 10.9282C6.94937 11.4746 7.39547 11.9216 7.94072 11.9216C8.2183 11.9216 8.46613 11.8124 8.64458 11.6335L13.6013 6.66618C13.7798 6.48736 13.8888 6.23899 13.8888 5.96082C13.8888 5.68265 13.7699 5.44422 13.5914 5.26539L8.63466 0.298041Z"
                fill="#8380A8"
              />
            </svg>
          </span>
        </button>
      </div>
      <img src="./images/q1_pic.png" class="questionGenPic" />
    </div>
  </div>
</template>

<script>
import store from "../store";
import BackButton from "./BackButton.vue";

export default {
  name: "Q1",
  components: {
    BackButton,
  },
  data() {
    return {
      answerOptions1: {
        0: "Yes",
        1: "No",
      },

      idArry: {
        0: "option1",
        1: "option2",
      },
      isActive: false,
      arr: [],
      checkedAnswers: [],
    };
  },

  mounted: function () {
    this.scrollToTop();
  },

  methods: {
    nextQuestion() {
      var answerArray = [];
      var activeChecked = [];

      this.findChecked("question8-1", answerArray);

      this.findCheckedID("question8-1", activeChecked, 0);

      var objectForPages = {
        index: '["questionNine"]',
        ans: answerArray,
      };

      var objectForChecked = {
        questionNum: '["questionNine"]',
        checkedButtons: activeChecked,
      };
      store.commit("addAnswer", objectForPages);
      store.commit("setNextButtonActive", '["questionNine"]');
      store.commit("setChecked", objectForChecked);
      store.commit("updatePage", '["results"]');
      store.commit("setNextButtonActive", '["questionNine"]');
      // store.commit("APPEND_SERVICE_TERM", objectForPages)
    },

    findChecked: function (name, arr) {
      var check = document.querySelector(
        "input[name = " + name + "]:checked"
      ).value;
      arr.push(check);
    },

    findCheckedID: function (name, arr, index) {
      var check = document.querySelector(
        "input[name = " + name + "]:checked"
      ).id;
      arr[index] = check;
    },

    setNextTrue() {
      this.scrollToBottom();
      this.isActive = true;
    },
    scrollToBottom: function () {
      window.scrollTo({
        top: document.body.scrollHeight,
        behavior: "smooth",
      });
    },
    scrollToTop: function () {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    },
  },
};
</script>
